import * as Yup from 'yup';
import { NewAthlete, User } from '@type/db-types';
import { formatAsISOJan1st } from '@utils/date-utils';

export enum AddWrestlerStepsEnum {
    WRESTLER_NAME = 0,
    WRESTLER_BIRTH = 1,
    WRESTLER_STATS = 2,
    WRESTLER_INVITE = 3,
}

type PrettifyType<T> = {
    [K in keyof T]: T[K];
} & {};

type EditUser = Partial<Pick<User, 'id'>>;

export type AddAthleteFormValues = PrettifyType<EditUser & NewAthlete>;

export const getInitialValues = (): AddAthleteFormValues => ({
    activeSince: formatAsISOJan1st(new Date()),
    birthday: '',
    email: '',
    firstName: '',
    gender: '',
    grade: '',
    lastName: '',
    weight: 0,
});

export const newWrestlerSchema: Yup.ObjectSchema<AddAthleteFormValues> = Yup.object({
    activeSince: Yup.string().ensure(),
    birthday: Yup.string().required('Birthday is required'),
    email: Yup.string().email('Invalid email').nullable().ensure(),
    firstName: Yup.string()
        .required('First name is required')
        .min(2, 'First name must be at least 2'),
    gender: Yup.string().required('Gender is required'),
    grade: Yup.string().ensure(),
    id: Yup.string().optional(),
    lastName: Yup.string().required('Last name is required').min(2, 'Last name must be at least 2'),
    weight: Yup.number()
        .required('Weight is required')
        .min(20, 'Weight must be at least 20')
        .max(500, 'Weight must be less than 500'),
});

const START_YEAR = 2000;
// generate array of seasons from 2000 to current year in the format "2000-2001"
export const ACTIVE_SINCE_OPTIONS = Array.from(
    { length: new Date().getFullYear() - START_YEAR },
    (_, i) => {
        const startYear = START_YEAR + 1 + i;
        return {
            label: `${startYear}-${startYear + 1}`,
            // value should be a string in this format: '2013-01-01T00:00:00+00:00'
            value: formatAsISOJan1st(new Date(`${startYear}-01-02`)), // use second day to avoid timezone issues
        };
    },
).reverse();
